module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#sports",
      toString: function () {
        return this.url;
      }
    }